import { InjectionToken } from '@angular/core';

/** Optional i18n error key handler for file validation in `ssc-files`. */
export const SSC_FILE_ERROR_HANDLER = new InjectionToken<
  (messageKey: string) => void
>('SSC_FILE_ERROR_HANDLER');
